export default __webpack_public_path__ + "static/media/2-5-selectAssessmentType.d9ebb3ce.png";